
import JsBarcode from 'jsbarcode';

export interface BarcodeGenerationOptions {
  format?: 'EAN13' | 'UPC' | 'CODE128' | 'auto';
  width?: number;
  height?: number;
  displayValue?: boolean;
  fontSize?: number;
  margin?: number;
}

export const generateBarcodeDataUrl = (
  barcodeData: string,
  options: BarcodeGenerationOptions = {}
): string | null => {
  if (!barcodeData) return null;

  const {
    format = 'auto',
    width = 1,
    height = 40,
    displayValue = false,
    fontSize = 12,
    margin = 0
  } = options;

  try {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    
    // Auto-detect format based on barcode data
    let barcodeFormat = format;
    if (format === 'auto') {
      const cleanData = barcodeData.replace(/\D/g, ''); // Remove non-digits
      if (cleanData.length === 13) {
        barcodeFormat = 'EAN13';
      } else if (cleanData.length === 12) {
        barcodeFormat = 'UPC';
      } else {
        barcodeFormat = 'CODE128';
      }
    }

    // Generate barcode
    JsBarcode(canvas, barcodeData, {
      format: barcodeFormat,
      width,
      height,
      displayValue,
      fontSize,
      margin,
      background: '#ffffff',
      lineColor: '#000000'
    });

    // Convert canvas to data URL
    return canvas.toDataURL('image/png');
  } catch (error) {
    console.error('Error generating barcode:', error);
    return null;
  }
};

export const generateBarcodeSvg = (
  barcodeData: string,
  options: BarcodeGenerationOptions = {}
): string | null => {
  if (!barcodeData) return null;

  const {
    format = 'auto',
    width = 1,
    height = 40,
    displayValue = false,
    fontSize = 12,
    margin = 0
  } = options;

  try {
    // Create an SVG element
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    
    // Auto-detect format based on barcode data
    let barcodeFormat = format;
    if (format === 'auto') {
      const cleanData = barcodeData.replace(/\D/g, ''); // Remove non-digits
      if (cleanData.length === 13) {
        barcodeFormat = 'EAN13';
      } else if (cleanData.length === 12) {
        barcodeFormat = 'UPC';
      } else {
        barcodeFormat = 'CODE128';
      }
    }

    // Generate barcode
    JsBarcode(svg, barcodeData, {
      format: barcodeFormat,
      width,
      height,
      displayValue,
      fontSize,
      margin,
      background: '#ffffff',
      lineColor: '#000000'
    });

    // Convert SVG to string
    return new XMLSerializer().serializeToString(svg);
  } catch (error) {
    console.error('Error generating barcode SVG:', error);
    return null;
  }
};
